/**
 * Barrel for the 17 enriched table semantic schemas and their registry.
 *
 * Consumers:
 *   - `registerPlanningDomain()` registers every schema so the table
 *     renderer and property panel can look them up by id.
 *   - Epic SP-D (ingestion) uses schemas as extraction targets.
 *   - Epic SP-B wires the schemas into the existing visual table
 *     schema at `src/domains/diagram/shapes/table/tableSchemas.registry.ts`.
 */

export * from './types';
export * from './registry';

export { SwotSchema } from './swot.schema';
export { TowsSchema } from './tows.schema';
export { KanbanSchema } from './kanban.schema';
export { RetroSchema } from './retro.schema';
export { RaciSchema } from './raci.schema';
export { EisenhowerSchema } from './eisenhower.schema';
export { BmcSchema } from './bmc.schema';
export { LeanSchema } from './lean.schema';
export { ComparisonSchema } from './comparison.schema';
export { RiskSchema } from './risk.schema';
export { StakeholderSchema } from './stakeholder.schema';
export { ImpactEffortSchema } from './impact-effort.schema';
export { MoscowSchema } from './moscow.schema';
export { AssumptionSchema } from './assumption.schema';
export { EmpathySchema } from './empathy.schema';
export { UserStorySchema } from './user-story.schema';
export { PrioritySchema } from './priority.schema';

import { SwotSchema } from './swot.schema';
import { TowsSchema } from './tows.schema';
import { KanbanSchema } from './kanban.schema';
import { RetroSchema } from './retro.schema';
import { RaciSchema } from './raci.schema';
import { EisenhowerSchema } from './eisenhower.schema';
import { BmcSchema } from './bmc.schema';
import { LeanSchema } from './lean.schema';
import { ComparisonSchema } from './comparison.schema';
import { RiskSchema } from './risk.schema';
import { StakeholderSchema } from './stakeholder.schema';
import { ImpactEffortSchema } from './impact-effort.schema';
import { MoscowSchema } from './moscow.schema';
import { AssumptionSchema } from './assumption.schema';
import { EmpathySchema } from './empathy.schema';
import { UserStorySchema } from './user-story.schema';
import { PrioritySchema } from './priority.schema';

import type { TableSemanticSchema } from './types';

export const PlanningTableSemanticSchemas: TableSemanticSchema[] = [
  SwotSchema,
  TowsSchema,
  KanbanSchema,
  RetroSchema,
  RaciSchema,
  EisenhowerSchema,
  BmcSchema,
  LeanSchema,
  ComparisonSchema,
  RiskSchema,
  StakeholderSchema,
  ImpactEffortSchema,
  MoscowSchema,
  AssumptionSchema,
  EmpathySchema,
  UserStorySchema,
  PrioritySchema,
];
